// @flow
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/styles';
import Button from '@material-ui/core/Button';

import SaveTranscriptIcon from '../Icons/SaveTranscript';

const useStyles = makeStyles(theme => ({
  heading: {
    color: theme.palette.ava.blue2,
    fontSize: 34,
    fontWeight: 700,
    lineHeight: '37.4px',
    [theme.breakpoints.down('sm')]: {
      fontSize: 30,
      lineHeight: '30px',
    },
  },
  text: {
    color: theme.palette.type === 'light' ? theme.palette.ava.dark1 : theme.palette.ava.white,
    fontSize: 18,
    lineHeight: '27px',
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
      lineHeight: '20px',
    },
  },
  icon: {
    marginBottom: -12,
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  saveButton: {
    margin: '0 50px',
    padding: '15px 0',
    background: theme.palette.ava.blue2,
    color: '#FFFFFF',
    fontSize: 20,
    lineHeight: '26px',
    borderRadius: 100,
    '&:hover': {
      backgroundColor: theme.palette.ava.blue1,
    },
    [theme.breakpoints.down('md')]: {
      margin: '0 40px',
    },
    [theme.breakpoints.down('sm')]: {
      margin: 0,
      fontSize: 18,
      lineHeight: '20px',
    },
  },
  notNowButton: {
    color: theme.palette.type === 'light' ? theme.palette.ava.blue2 : theme.palette.ava.white,
    fontSize: 18,
    lineHeight: '27px',
    '&:hover': {
      backgroundColor: 'initial',
      color: theme.palette.type === 'light' ? theme.palette.ava.blue1 : theme.palette.ava.blue4,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
      lineHeight: '20px',
    },
  },
}));

interface Props {
  onSaveClicked: Function;
  onNotNowClicked: Function;
}

const SaveTranscriptDialog1 = ({ onSaveClicked, onNotNowClicked }: Props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const [screen, setScreen] = useState({
    height: window.innerHeight,
    width: window.innerWidth,
  });

  useEffect(() => {
    const handleResize = () => {
      setScreen({
        height: window.innerHeight,
        width: window.innerWidth,
      });
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const getTranscriptIconDimensions = () => {
    if (screen.width < screen.height) {
      return {
        width: screen.width * 0.3,
        height: screen.width * 0.3 - 5,
      };
    }

    return {
      width: screen.height * 0.25,
      height: screen.height * 0.25 - 5,
    };
  };

  return (
    <>
      <h3 className={classes.heading}>{t('saveTranscript.dialog1.heading')}</h3>
      <div className={classes.text}>{t('saveTranscript.dialog1.text')}</div>
      <div className={classes.icon}>
        <SaveTranscriptIcon {...getTranscriptIconDimensions()} />
      </div>
      <div className={classes.buttonContainer}>
        <Button className={classes.saveButton} onClick={onSaveClicked}>
          {t('saveTranscript.dialog1.saveButton')}
        </Button>
        <Button className={classes.notNowButton} onClick={onNotNowClicked}>
          {t('saveTranscript.dialog1.notNowButton')}
        </Button>
      </div>
    </>
  );
};

export default SaveTranscriptDialog1;
